import type { ReferenceRenderer } from '@contember/react-client'
import type { ContentReferenceResult } from '../../data/ContentFragment'

type ReferenceRenderers = {
	[Key in ContentReferenceResult['type']]: ReferenceRenderer<ContentReferenceResult & { type: Key }, never, never>
}

export function ensureAllReferences<R extends ReferenceRenderers>(references: R) {
	return references
}
